/**
 * Parses the FavoriteUsers localStorage string into a lookup map.
 *
 * Storage format: comma-separated entries of "userId&email"
 * e.g. "42&alice@example.com,7&bob@example.com"
 *
 * Entries missing either an id or email are filtered out to avoid spurious matches.
 *
 * @returns Record mapping userId → email for all valid favorites
 */
export const parseFavoriteUsers = (raw: string): Record<string, string> =>
  Object.fromEntries(
    raw
      .split(',')
      .map(fav => fav.split('&'))
      .filter(([id, email]) => !!id && !!email) // skip malformed entries that would produce spurious {} keys
  );
